// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-button[data-v-9fe4cdba] {\n  cursor: pointer;\n  padding: 6px;\n  background-color: #eee;\n  max-height: 30px;\n}\n.icon-button span[data-v-9fe4cdba] {\n  width: 12px;\n  height: 12px;\n  font-family: TirScript;\n  display: flex;\n}\n", ""]);
// Exports
module.exports = exports;
